<template>
  <div class="space-y-4">
    <div
      :class="{
        'space-y-2': variant === 'list',
        'flex flex-wrap gap-2': variant === 'cloud',
      }">
      <FilterProfiles :variant="variant" />
      <FilterProducts :variant="variant" />
      <FilterCategory :variant="variant" />
      <FilterMediaType :variant="variant" />
      <FilterUrgencies :variant="variant" />
      <FilterGenres :variant="variant" />
      <FilterStatusTags :variant="variant" />
      <FilterUserNeed :variant="variant" />
      <FilterTShirtSizes :variant="variant" />
      <FilterDate :variant="variant" />
    </div>
    <div v-if="hasAnyActiveFilter">
      <ResetFilter />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";

import FilterProfiles from "@/components/archive/FiltersSelector/FilterProfiles.vue";
import useFilterSelectorStore from "@/stores/search/filterSelector.ts";

import FilterCategory from "./FilterCategory.vue";
import FilterDate from "./FilterDate.vue";
import FilterGenres from "./FilterGenres.vue";
import FilterMediaType from "./FilterMediaType.vue";
import FilterProducts from "./FilterProducts.vue";
import type { FilterSelectorVariant } from "./filterSelectorItemWrapper";
import FilterStatusTags from "./FilterStatusTags.vue";
import FilterTShirtSizes from "./FilterTShirtSizes.vue";
import FilterUrgencies from "./FilterUrgencies.vue";
import FilterUserNeed from "./FilterUserNeed.vue";
import ResetFilter from "./ResetFilter.vue";

const filterSelectorStore = useFilterSelectorStore();
const { hasAnyActiveFilter } = storeToRefs(filterSelectorStore);

const { variant = "list" } = defineProps<{
  variant?: FilterSelectorVariant;
}>();
</script>
